import { useUser } from '@acme/domains';
import { Button } from 'flowbite-react';

export function BlockedUserPage() {
  const { logout } = useUser();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-8">
      <div className="mb-8">
        <svg
          className="mx-auto h-24 w-24 text-red-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>

      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Доступ ограничен
      </h1>

      <p className="text-lg text-gray-600 mb-8 max-w-md">
        Ваш аккаунт был заблокирован. Для получения дополнительной информации
        обратитесь в службу поддержки.
      </p>

      <Button onClick={() => logout()} color="gray">
        Выход
      </Button>
    </div>
  );
}
